import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zoom",
  "use": "icon-zoom-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-zoom\"><path d=\"M23.625 6.75h5.625v5.625m-7.875 2.25L29.25 6.75m-16.875 22.5H6.75v-5.625m7.875-2.25L6.75 29.25m22.5-5.625v5.625h-5.625m-2.25-7.875 7.875 7.875M6.75 12.375V6.75h5.625m2.25 7.875L6.75 6.75\" stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol